// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__293dP","main-image":"Header_main-image__1P2Mg"};